<div class="container">
    <rr-start-logo class="logo" color="inverse" routerLink="/"></rr-start-logo>
    <div class="content">
        <h1>Hier sind unsere FAQ's.</h1>
        @for (block of faqObject; track block) {
            <h2>{{ block.blockheadline }}</h2>
            @for (item of block.faqs; track item) {
                <section>
                    <h3>{{ item.question }}</h3>
                    <p innerHTML="{{ item.answer }}"></p>
                </section>
            }
        }
    </div>
</div>
<rr-disclaimer [type]="disclaimerTypeFooter" [showIcon]="false"></rr-disclaimer>
